import { c as _c } from "react/compiler-runtime";
import { Fragment } from "react";
import { Menu, MenuButton, MenuItems, Transition } from "@headlessui/react";
import OverflowDots from "@catchy/assets/svgs/overflow-dots.svg";
import IconButton from "./IconButton";
export default function OptionsMenu(t0) {
  const $ = _c(6);
  const {
    isApple,
    children,
    label: t1,
    trigger,
    variant: t2
  } = t0;
  const label = t1 === undefined ? "More options" : t1;
  const variant = t2 === undefined ? "default" : t2;
  let t3;
  if ($[0] !== children || $[1] !== isApple || $[2] !== label || $[3] !== trigger || $[4] !== variant) {
    t3 = <Menu as="div" className="relative outline-none">{t4 => {
        const {
          open
        } = t4;
        return <><MenuButton as={IconButton} label={label} variant={variant}>{trigger || <OverflowDots aria-hidden="true" className={`h-6 w-6 ${isApple ? "rotate-90" : ""}`} />}</MenuButton><Transition show={open} as={Fragment} enter="transition-opacity duration-500" enterFrom="opacity-0" enterTo="opacity-100" leave="transition-opacity duration-200" leaveFrom="opacity-100" leaveTo="opacity-0"><div className="fixed inset-0 z-10 bg-zinc-950/30 opacity-100 motion-reduce:transition-none motion-reduce:opacity-100 sm:bg-transparent dark:bg-zinc-950/70" aria-hidden="true" /></Transition><Transition as={Fragment} show={open} enter="transition ease-out duration-200" enterFrom="opacity-0 sm:-translate-y-2 translate-y-10" enterTo="opacity-100 translate-y-0" leave="transition ease-in duration-150" leaveFrom="opacity-100 translate-y-0" leaveTo="opacity-0 sm:-translate-y-2 translate-y-5"><MenuItems className="fixed bottom-0 left-0 right-0 z-50 w-full rounded-t-xl bg-white pb-10 pt-3 shadow-lg ring-1 ring-zinc-200 motion-reduce:transition-none motion-reduce:opacity-100 motion-reduce:translate-y-0 focus:outline-none sm:absolute sm:bottom-auto sm:left-auto sm:right-0 sm:mt-2 sm:w-72 sm:rounded-lg sm:py-0 sm:motion-reduce:translate-y-0 dark:bg-zinc-800 dark:ring-0" modal={false}>{children}</MenuItems></Transition></>;
      }}</Menu>;
    $[0] = children;
    $[1] = isApple;
    $[2] = label;
    $[3] = trigger;
    $[4] = variant;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}